import {takeEvery, takeLatest, put, call, all, fork} from "redux-saga/effects"

import {
  SIMPLE_FILES_FILTER,
  SIMPLE_FILES_SEGMENTS,
  SIMPLE_FILES_LIST,
  SIMPLE_FILES_DOWNLOAD,
} from "./actionTypes"

import {
  simpleFilesFilterSuccess,
  simpleFilesFilterError,
  simpleFilesSegmentsSuccess,
  simpleFilesSegmentsError,
  simpleFilesListSuccess,
  simpleFilesListError,
} from "./actions"

import {
  apiGetSimpleFilesFilter,
  apiPostSimpleFilesSegments,
  apiGetSimpleFilesList,
  apiDownloadSimpleFilesDownload,
} from "../../api/calls/simpleFiles"

function* simpleFilesFilter({payload: data}) {
  try {
    const response = yield call(apiGetSimpleFilesFilter, data)
    yield put(simpleFilesFilterSuccess(response))
  } catch (error) {
    yield put(simpleFilesFilterError(error))
  }
}

function* simpleFilesSegments({payload: data}) {
  try {
    const response = yield call(apiPostSimpleFilesSegments, data)
    yield put(simpleFilesSegmentsSuccess(response))
  } catch (error) {
    yield put(simpleFilesSegmentsError(error))
  }
}

function* simpleFilesList({payload: data}) {
  try {
    const response = yield call(apiGetSimpleFilesList, data)
    yield put(simpleFilesListSuccess(response))
  } catch (error) {
    yield put(simpleFilesListError(error))
  }
}

function* simpleFilesDownload({payload: data}) {
  try {
    yield call(apiDownloadSimpleFilesDownload, data)
  } catch (error) {
  }
}

export function* watchSimpleFilesFilter() {
  yield takeEvery(SIMPLE_FILES_FILTER, simpleFilesFilter);
}

export function* watchSimpleFilesSegments() {
  yield takeEvery(SIMPLE_FILES_SEGMENTS, simpleFilesSegments);
}

export function* watchSimpleFilesList() {
  yield takeLatest(SIMPLE_FILES_LIST, simpleFilesList);
}

export function* watchSimpleFilesDownload() {
  yield takeLatest(SIMPLE_FILES_DOWNLOAD, simpleFilesDownload);
}

function* simpleFilesSaga() {
  yield all([
    fork(watchSimpleFilesFilter),
    fork(watchSimpleFilesSegments),
    fork(watchSimpleFilesList),
    fork(watchSimpleFilesDownload),
  ]);
}

export default simpleFilesSaga
